import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./BooksUIHelpers";

const BooksUIContext = createContext();

export function useBooksUIContext() {
  return useContext(BooksUIContext);
}

export const BooksUIConsumer = BooksUIContext.Consumer;

export function BooksUIProvider({ booksUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewBookPage: booksUIEvents.openNewBookPage,
    openEditBookPage: booksUIEvents.openEditBookPage
  };

  return (
    <BooksUIContext.Provider value={value}>
      {children}
    </BooksUIContext.Provider>
  );
}